import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackDialogComponent } from '@mp-shared/components/feedback-dialog/feedback-dialog.component';

@Component({
  selector: 'mp-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {

  constructor(private matDialog: MatDialog) {
  }

  openFeedbackDialog() {
    this.matDialog.open(FeedbackDialogComponent, {
      minWidth: '40%',
    });
  }
}
